import React from "react";
type WaveProps = {
  fill: string;
};

// Curva suave que se apoya en el borde inferior de una sección
// y se pinta con el color de la sección siguiente.
export function Wave({
  fill
}: WaveProps) {
  return <svg aria-hidden="true" className="pointer-events-none absolute inset-x-0 -bottom-px h-7 w-full sm:h-10" viewBox="0 0 720 40" preserveAspectRatio="none" data-id="element-210" data-mp="2780thj4lr14g">
      <path d="M0 40V24C120 6 240 0 360 10C480 20 600 30 720 14V40Z" fill={fill} data-id="element-211" data-mp="2c0u3omiub1nx" />
    </svg>;
}